import { useState } from "react";
import type { CreateCategoryAttributeRequest } from "@/services/api";
import {
  AttributesPanelHeader,
  AttributesTable,
  AttributeCreateDialog,
  AttributeEditDialog,
  AttributeDeleteDialog,
  CategoriesLinkedModal,
  ValuesModal,
  useAttributesPanel,
} from "./attributes";

export function AttributesPanel() {
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);
  const {
    attributes,
    isLoading,
    sortField,
    sortDirection,
    editingAttribute,
    deletingAttribute,
    viewingCategoriesAttribute,
    viewingValuesAttribute,
    handleSort,
    handleCreate,
    handleUpdate,
    handleDelete,
    setEditingAttribute,
    setDeletingAttribute,
    setViewingCategoriesAttribute,
    setViewingValuesAttribute,
    createIsLoading,
    updateIsLoading,
    deleteIsLoading,
    attributesCount,
  } = useAttributesPanel();

  return (
    <div className="w-full space-y-6">
      <AttributesPanelHeader
        attributesCount={attributesCount}
        onCreateClick={() => setIsCreateDialogOpen(true)}
      />

      <div className="rounded-xl border border-grid-200 bg-white shadow-sm">
        {isLoading ? (
          <div className="py-12 text-center text-sm text-ink-500">
            Loading attributes...
          </div>
        ) : (
          <AttributesTable
            attributes={attributes}
            sortField={sortField}
            sortDirection={sortDirection}
            onSort={handleSort}
            onEdit={(attribute) => setEditingAttribute(attribute)}
            onDelete={(attribute) => setDeletingAttribute(attribute)}
            onViewCategories={(attribute) =>
              setViewingCategoriesAttribute(attribute)
            }
            onViewValues={(attribute) => setViewingValuesAttribute(attribute)}
          />
        )}
      </div>

      <AttributeCreateDialog
        open={isCreateDialogOpen}
        isLoading={createIsLoading}
        onOpenChange={setIsCreateDialogOpen}
        onSubmit={(data: CreateCategoryAttributeRequest) => {
          handleCreate(data);
          setIsCreateDialogOpen(false);
        }}
      />

      <AttributeEditDialog
        open={!!editingAttribute}
        attribute={editingAttribute}
        isLoading={updateIsLoading}
        onOpenChange={(open) => !open && setEditingAttribute(null)}
        onSubmit={handleUpdate}
      />

      <AttributeDeleteDialog
        open={!!deletingAttribute}
        attribute={deletingAttribute}
        isLoading={deleteIsLoading}
        onOpenChange={(open) => !open && setDeletingAttribute(null)}
        onConfirm={handleDelete}
      />

      <CategoriesLinkedModal
        open={!!viewingCategoriesAttribute}
        onOpenChange={(open) => !open && setViewingCategoriesAttribute(null)}
        attribute={viewingCategoriesAttribute}
      />

      <ValuesModal
        open={!!viewingValuesAttribute}
        onOpenChange={(open) => !open && setViewingValuesAttribute(null)}
        attribute={viewingValuesAttribute}
      />
    </div>
  );
}
